import React from "react";
import '../Styling/Components.css';
import '../Styling/Home.css';
import Footer from './Footer';
import ProfilePic from '../Styling/Assets/ProfileImg.jpg';

export default function Home() {
    return (
        <div className="profile-container">
            <div className="profile-content-container">
                <div className="profile-image-container">
                    <img
                        src={ProfilePic}
                        className="d-inline-block profile-pic"
                        alt="ProfilePicture"
                    />
                </div>
                <div className="profile-description">
                    <h1>BRYAN NICHOLAS CARTER</h1>
                    <h3>actor • producer • podcast host</h3>
                    <p>
                        Bryan Nicholas Carter, he/him is a Chicago based actor, producer and podcast host.
                    </p>
                    <p>
                        Bryan is currently preparing to enter rehearsals with Steppenwolf Theatre for their upcoming world premier production of Windfall by Tarell Alvin Mccraney which runs through April 19th through May 31st 2026.
                    </p>
                    <p>
                        Recent credits include, <a href="https://chicagoreader.com/performing-arts/theater/theater-review/house-that-will-not-stand-invictus-theatre/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}><i>The House That Will Not Stand</i></a> (Invictus Theatre); <a href="https://www.newcitystage.com/2025/09/26/sex-violence-and-daddy-issues-in-gangsta-baby-at-open-space-arts/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}><i>Gangsta Baby</i></a> (Open Space Arts); and, <a href="https://www.chicagotribune.com/2025/01/15/review-kid-prince-and-pablo-by-lifeline-theatre-adds-hip-hop-score-to-a-classic-twain-tale/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}><i>Kid Prince & Pablo</i></a> (Lifeline Theatre) as well as <a href="https://chicagoreader.com/performing-arts/theater/theater-review/bob-marleys-three-little-birds-young-peoples-theatre-of-chicago/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}><i>Bob Marley’s Three Little Birds</i></a> (Young People’s Theatre of Chicago). Bryan recently wrapped filming for the upcoming feature film, Keep Still (The Good Fight Films). <a  href="/experience" style={{ color: 'black' }}>See Full Credits</a>
                    </p>
                    <p>
                        In 2020 Carter received prominent recognition by the Kennedy Center American College Theatre Festival, being awarded the national honor for Best Actor in an Outstanding Role as Nat Turner in Nat Turner in Jerusalem (University of Wisconsin Oshkosh) directed by Merlaine Angwall.                   
                    </p>
                    <p>
                        From 2020 to 2022, Bryan worked closely with Best-Selling Author and Personal Brand Strategist, Jessica Zweig, producing several live and virtual events as well as producing and guest hosting her podcast, <i>The SimplyBe.</i> Podcast, now the <i>Spiritual Hustler Podcast</i>.
                    </p>
                    <p>
                        Carter is an alumnus of The School at Steppenwolf and holds his B.A. in Political Science.
                    </p>             
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </div>
    );
}
